/* eslint-disable no-console */
import MockAnalyticsStore from "../MockAnalyticsStore";
import loadSegment from "./loadSegment";
import segmentApiKey from "./segmentApiKey";
import sanitizeTraits from "../sanitizeTraits";
import { getEnv } from "../env";
let analytics;
const { GOLDEN_GATE, NODE_ENV } = getEnv();
// Regexes to determine the project UID from the URL
const PLANGRID_PROJECT_REGEXES = [
  /^\/projects\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/,
  /^\/app\/projects\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/,
];
const GOLDEN_GATE_PROJECT_REGEX =
  /\/projects\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/;
function getProjectUidFromWindowLocation() {
  const url = new URL(window.location.href);
  if (GOLDEN_GATE) {
    const match = GOLDEN_GATE_PROJECT_REGEX.exec(url.pathname);
    if (match) return match[1];
  } else {
    const match = PLANGRID_PROJECT_REGEXES.map((r) => r.exec(url.pathname))[0];
    if (match) return match[1];
  }
  return null;
}
function addProjectUidToProperties(properties) {
  const projectUid = getProjectUidFromWindowLocation();
  // TODO: Add data_center
  return {
    user_type: GOLDEN_GATE ? "acc" : "plangrid",
    project_type: GOLDEN_GATE ? "acc" : "plangrid",
    screen_height: window.innerHeight,
    screen_width: window.innerWidth,
    ...(projectUid && { project_id: projectUid }),
    ...properties,
  };
}
if (NODE_ENV === "production") {
  loadSegment(segmentApiKey());
  analytics = {
    setBaseProperties(properties) {
      window.accAnalyticsBaseProperties = {
        ...window.accAnalyticsBaseProperties,
        ...properties,
      };
    },
    track(event, properties) {
      window.analytics.track(
        event,
        addProjectUidToProperties({
          ...window.accAnalyticsBaseProperties,
          ...properties,
        })
      );
    },
    identify(userId, traits) {
      window.analytics.identify(userId, sanitizeTraits(traits));
    },
  };
} else if (NODE_ENV === "test") {
  analytics = {
    setBaseProperties(properties) {
      MockAnalyticsStore._recordSetBaseProperties(properties);
    },
    track(event, properties) {
      MockAnalyticsStore._recordTrack(event, properties);
    },
    identify(userId, traits) {
      MockAnalyticsStore._recordIdentify(userId, sanitizeTraits(traits));
    },
  };
} else {
  analytics = {
    setBaseProperties(properties) {
      window.accAnalyticsBaseProperties = properties;
      console.log(
        "%c[analytics.setBaseProperties] %cprops=",
        "color:cornflowerblue",
        "color:slategrey",
        "color:black;font-weight:600",
        "color:slategrey",
        properties
      );
    },
    track(event, properties) {
      properties = addProjectUidToProperties(
        { ...window.accAnalyticsBaseProperties, ...properties } || {}
      );
      console.log(
        "%c[analytics.track] %cevent=%c" + event + " %cprops=",
        "color:cornflowerblue",
        "color:slategrey",
        "color:black;font-weight:600",
        "color:slategrey",
        properties
      );
    },
    identify(userId, traits) {
      if (traits)
        console.log(
          "%c[analytics.identify] %cuserId=%c" + userId + " %ctraits=",
          "color:cornflowerblue",
          "color:slategrey",
          "color:black;font-weight:600",
          "color:slategrey",
          sanitizeTraits(traits)
        );
      else
        console.log(
          "%c[analytics.identify] %cuserId=%c" + userId,
          "color:cornflowerblue",
          "color:slategrey",
          "color:black;font-weight:600"
        );
    },
  };
}
export default analytics;
